import React from "react";
import apiFetch from "@wordpress/api-fetch";

import MarqueeTitle from "./components/MarqueeTitle";
import PlayerControls from "./components/PlayerControls";
import Loading from "./components/Loading";
import Cassettes from "./components/Cassettes";

const SpeakerImg = `/wp-content/plugins/rockinrudys/images/player-speaker.png`;
const handLeft = `/wp-content/plugins/rockinrudys/images/hand-left.png`;
const handRight = `/wp-content/plugins/rockinrudys/images/hand-right.png`;
const cassetteFront = `/wp-content/plugins/rockinrudys/images/cassette.png`;

export default class Edit extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			visible: false,
			loading: true,
			person: null,
			persons: null,
			player: {
				playing: false,
				ejected: false,
			},
		};

		this._content = React.createRef();
	}

	componentDidMount() {
		this.checkVisible();
		this.listen();
	}

	componentWillUnmount() {
		window.removeEventListener("scroll", this.checkVisible);
	}

	checkVisible = async () => {
		if (!this.state.visible) {
			const getWindowBoundingBox = () => {
				return {
					left: 0,
					top: 0,
					right: window.innerWidth,
					bottom: window.innerHeight,
				};
			};

			const boundingBoxesCollide = (a, b) => {
				return (
					a.left < b.right &&
					b.left < a.right &&
					a.top + 250 < b.bottom
				);
			};

			const containerRect = this._content.current.getBoundingClientRect();
			if (boundingBoxesCollide(containerRect, getWindowBoundingBox())) {
				this.setState(
					{
						visible: true,
					},
					this.loadPersons
				);

				return true;
			}
		}

		return false;
	};

	listen() {
		window.addEventListener("scroll", this.checkVisible, true);
	}

	async loadPersons() {
		const persons = await this.fetchPersons();

		this.setState({
			loading: false,
			persons,
			person: !this.state.person ? persons[0] : null,
			player: {
				...this.state.player,
				playing: false,
			},
		});
	}

	loadPerson(person) {
		this.setState({
			person,
		});
	}

	fetchPersons() {
		this.setState({
			loading: true,
		});

		return apiFetch({ path: `/rockinrudys/v1/persons` });
	}

	getCassettes = () => {
		const { persons } = this.state;

		if (!this.state.persons) {
			return null;
		}

		return persons.map((person) => ({
			id: person.ID,
			label: person.post_title,
			image: person.acf_fields.album_cassette
				? person.acf_fields.album_cassette.url
				: cassetteFront,
		}));
	};

	getAlbumUrl = (data, size) => {
		return data.sizes[size];
	};

	handleCassetteSelect = (id) => {
		const person = this.state.persons.find((p) => p.ID === id);
		if (person) {
			this.setState({
				person,
				player: {
					...this.state.player,
					ejected: false,
				},
			});
		}
	};

	onNextClick = (e) => {
		const currentIndex = this.state.persons.findIndex(
			(p) => p.ID === this.state.person.ID
		);
		const nextIndex = currentIndex + 1;
		this.setState({
			person:
				nextIndex > this.state.persons.length - 1
					? this.state.persons[0]
					: this.state.persons[nextIndex],
		});
	};

	onPrevClick = (e) => {
		const currentIndex = this.state.persons.findIndex(
			(p) => p.ID === this.state.person.ID
		);
		const nextIndex = currentIndex - 1;
		this.setState({
			person:
				nextIndex < 0
					? this.state.persons[this.state.persons.length - 1]
					: this.state.persons[nextIndex],
		});
	};

	handlePlay = (e) => {
		this.setState({
			player: {
				...this.state.player,
				playing: true,
			},
		});
	};

	handlePause = (e) => {
		this.setState({
			player: {
				...this.state.player,
				playing: false,
			},
		});
	};

	handleEject = (e) => {
		this.setState({
			person: null,
			player: {
				...this.state.player,
				ejected: true,
			},
		});
	};

	renderCards = () => {
		if (!this.state.visible) {
			return null;
		}

		if (this.state.loading) {
			return <Loading />;
		}

		if (!this.state.person) {
			return (
				<div className="no-results">Please select a tape cassette</div>
			);
		}
		const out = [];
		this.state.person.acf_fields.album_picks.forEach((album, i) => {
			const cardStyles = {
				backgroundImage: `url(${this.getAlbumUrl(
					album.album_cover,
					"thumbnail"
				)})`,
			};

			out.push(
				<a
					className="gecko-tape-recorder__card"
					href={album["album_link"]}
					style={cardStyles}
					key={`recorder__card-${i}`}
				>
					<div className="gecko-tape-recorder__card-overlay">
						<h3 className="gecko-tape-recorder__card-overlay__title">
							<strong>{album["album_artist"]}</strong>
						</h3>
						<p className="gecko-tape-recorder__card-overlay__album">
							{album["album_title"]}
						</p>
						<div className="gecko-tape-recorder__card-overlay__plus" />
					</div>
				</a>
			);
		});

		out.push(
			<div
				className="gecko-tape-recorder__card gecko-tape-recorder__card--dummy"
				key={`recorder__card-${out.length + 1}`}
			/>
		);
		out.push(
			<div
				className="gecko-tape-recorder__card gecko-tape-recorder__card--dummy"
				key={`recorder__card-${out.length + 2}`}
			/>
		);

		return out;
	};

	getUserTape = (person) => {
		if (!person) {
			return null;
		}

		if (person.acf_fields["album_cassette"]) {
			return person.acf_fields["album_cassette"].url;
		} else {
			return cassetteFront;
		}
	};

	render() {
		const playerClasses = [
			"gecko-tape-recorder__player",
			this.state.player.playing && this.state.person ? "playing" : null,
		];

		const footerClasses = [
			"gecko-tape-recorder__player-footer",
			this.state.player.playing && this.state.person ? "playing" : null,
		];

		return (
			<div className="gecko-tape-recorder__inner" onClick={this.onClick}>
				<div className={playerClasses.join(" ")}>
					<img
						src={handLeft}
						className="gecko-tape-recorder__hand gecko-tape-recorder__hand--left"
						onClick={this.onPrevClick}
						alt="Load Previous Cassette"
					/>
					<img
						src={handRight}
						className="gecko-tape-recorder__hand gecko-tape-recorder__hand--right"
						onClick={this.onNextClick}
						alt="Load Next Cassette"
					/>
					<div className="gecko-tape-recorder__player-header">
						<div
							className="gecko-tape-recorder__player-speaker"
							role="presentation"
						>
							<img src={SpeakerImg} alt="Speaker Grille" />
						</div>
						<MarqueeTitle
							play={
								this.state.player.playing &&
								!this.state.player.ejected
							}
							title={
								this.state.person
									? this.state.person.post_title
									: this.state.loading
									? "Loading..."
									: "-"
							}
						/>
						<div
							className="gecko-tape-recorder__player-speaker"
							role="presentation"
						>
							<img src={SpeakerImg} alt="Speaker Grille" />
						</div>
					</div>
					<div
						ref={this._content}
						className="gecko-tape-recorder__player-content"
					>
						{this.renderCards()}
					</div>
				</div>
				<div className={footerClasses.join(" ")}>
					<PlayerControls
						cassetteImage={this.getUserTape(this.state.person)}
						person={this.state.person}
						onRecord={this.handlePause}
						onPlay={this.handlePlay}
						onRewind={this.handlePause}
						onFastFwd={this.handlePause}
						onEject={this.handleEject}
						onPause={this.handlePause}
						player={this.state.player}
					/>
				</div>
				<Cassettes
					items={this.getCassettes()}
					activeCassette={this.state.person}
					onSelect={this.handleCassetteSelect}
				>
					<img
						src={handLeft}
						className="gecko-tape-recorder__hand-mobile gecko-tape-recorder__hand-mobile--left"
						onClick={this.onPrevClick}
						alt="Load Previous Cassette"
					/>
					<img
						src={handRight}
						className="gecko-tape-recorder__hand-mobile gecko-tape-recorder__hand-mobile--right"
						onClick={this.onNextClick}
						alt="Load Next Cassette"
					/>
				</Cassettes>
			</div>
		);
	}
}
